import { Directive, HostListener, input, output } from '@angular/core';

@Directive({
  selector: '[addClick]',
})
export class AddClickDirective {
  row = input.required<number>();
  col = input.required<'Operational' | 'Occupied'>();
  click = output<{ row: number; col: 'Operational' | 'Occupied' }>();

  @HostListener('mousedown')
  onClick() {
    this.click.emit({ row: this.row(), col: this.col() });
  }
}
